<template>
  <div class="appNav">
    <div class="appNav__controls">
      <div
        v-if="!navPlacement || navPlacement === 'navbar'"
        class="appNav__logo"
      >
        <router-link to="/home">
          <img
            v-if="settings.logoImgSource"
            :src="settings.logoImgSource"
            alt="Tangle"
          />
          <img v-else src="@/assets/imgs/logo-navbar.png" alt="Tangle" />
        </router-link>
      </div>
      <div class="appNav__center">
        <div class="appNav__dashTitle" v-if="dashTitle">
          <h2>{{ dashTitle }}</h2>
        </div>
        <div class="appNav__center no_grow">
          <b-input-group v-if="isHome">
            <template v-slot:prepend>
              <b-input-group-text
                is-text
                class="pt-0 pb-0 pr-2 pl-2 search_icon"
              >
                <icon name="search" />
              </b-input-group-text>
            </template>
            <b-form-input
              size="sm"
              placeholder="Search"
              class="search_input"
              @input="searchDashboards"
              ref="search_input"
            />
          </b-input-group>
          <b-button
            v-if="isHome"
            class="ml-2"
            variant="success"
            @click="createNewDashboard"
            size="sm"
          >
            <b>Add new</b>
          </b-button>
        </div>
        <div class="appNav__tabsMenu">
          <slot name="tabsMenu" />
        </div>
      </div>
      <ul class="appNav__items">
        <li
          v-if="$can('update', 'Dashboard_' + currentDash) && isDataLoaded"
          class="appNav__item"
          v-b-tooltip.hover
          title="Add Card"
        >
          <b-link
            :style="{ color: '#2dce89' }"
            href="#"
            @click.prevent="showWidgetsList"
            :disabled="!isDataLoaded"
          >
            <icon name="plus-square" style="vertical-align: -6px;" />
          </b-link>
        </li>
        <li
          v-if="$can('update', 'Dashboard_' + currentDash) && isDataLoaded"
          class="appNav__item"
          v-b-tooltip.hover
          title="Build Schema"
        >
          <b-link
            @click.prevent="showBuildSchemaModal"
          >
            <icon name="table" style="vertical-align: -8px;" />
          </b-link>
        </li>
        <li
          v-if="$can('update', 'Dashboard_' + currentDash) && isDataLoaded"
          class="appNav__item"
          v-b-tooltip.hover
          title="Simple Workflow"
        >
          <a href="#" @click.prevent="showSimpleWorkflowModal">
            <icon name="tasks" style="vertical-align: -7px;" />
          </a>
        </li>
        <li
          v-if="$can('update', 'Dashboard_' + currentDash) && isDataLoaded"
          class="appNav__item"
          v-b-tooltip.hover
          title="Custom Code"
        >
          <b-link
            href="#"
            @click.prevent="showCustomCode"
          >
            <icon name="code" />
          </b-link>
        </li>
        <li
          v-if="$can('update', 'Dashboard_' + currentDash) && isDataLoaded"
          class="appNav__item"
          v-b-tooltip.hover
          title="Computed"
        >
          <b-link
            href="#"
            @click.prevent="showComputed"
          >
            <!-- <icon
              name="square-root-alt"
            /> -->
            <i class="fas fa-square-root-alt"></i>
          </b-link>
        </li>
        <li
          v-if="$can('update', 'Dashboard_' + currentDash) && isDataLoaded"
          class="appNav__item"
          v-b-tooltip.hover
          title="Settings"
        >
          <b-link
            href="#"
            @click.prevent="showSettings"
          >
            <icon name="cog" />
          </b-link>
        </li>
        <li
          v-if="$can('update', 'Dashboard_' + currentDash) && isDataLoaded"
          class="appNav__item"
          v-b-tooltip.hover
          title="Workflows"
        >
          <b-link
            href="#"
            @click.prevent="showWorkflows"
          >
            <!-- <icon
              name="bezier-curve"
            /> -->
            <i class="fas fa-bezier-curve"></i>
          </b-link>
        </li>
        <li
          v-if="$can('all', 'Admin')"
          class="appNav__item"
          v-b-tooltip.hover
          title="Manage Access"
        >
          <router-link to="/control-panel">
            <icon name="lock" />
          </router-link>
        </li>
        <li
          v-if="
            $can('all', 'Admin') ||
            $can('manageUsers', 'Dashboard_' + currentDash)
          "
          class="appNav__item"
          v-b-tooltip.hover
          title="Invite User"
        >
          <a href="#" @click="showInviteUserModal">
            <icon name="share-alt-square" />
          </a>
        </li>
        <li v-if="isUserAnonymous" class="appNav__item">
          <router-link to="/auth/anonymous">Sign Up</router-link>
        </li>
        <li class="appNav__item" v-b-tooltip.hover title="Reset Password">
          <router-link to="/reset-pass">
            <icon name="user-circle" />
          </router-link>
        </li>
        <li class="appNav__item" v-b-tooltip.hover title="Sign Out">
          <a href="#" @click.prevent="signOut">
            <icon name="sign-out" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import auth from '@/services/auth'
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  name: 'NavBar',
  props: ['dashTitle', 'navPlacement', 'isDataLoaded'],
  computed: {
    ...mapState(['isUserAnonymous', 'userId', 'settings', 'currentDash']),
    isHome() {
      return this.$route.name == 'Home' ? true : false
    },
  },
  methods: {
    createNewDashboard() {
      this.$emit('createNewDashboard')
    },
    searchDashboards($event) {
      this.$emit('searchDashboards', $event)
    },
    signOut() {
      auth.signOut(this.isUserAnonymous, this.userId, err => {
        this.$store.commit('markUserAsAnonymous', false)
        this.$store.commit('destroyCasl')

        if (err) {
          this.$store.commit('addError', err.message)
        } else {
          // this.$router.push('/auth')
          localStorage.removeItem('lastDash')
          localStorage.removeItem('workspace')
          window.location = '/auth'
        }
      })
    },
    showWidgetsList(e) {
      const titleHolder = $(e.target).closest('a')
      $(`#${$(titleHolder).attr('aria-describedby')}`).attr(
        'style',
        'display: none !important'
      )

      this.$store.commit('toolsPanel_setItem', {
        id: 'addWidget',
      })
    },
    showExtensionsDropdown(e) {
      const titleHolder = $(e.target).closest('.appNav__item')
      $(`#${$(titleHolder).attr('aria-describedby')}`).attr(
        'style',
        'display: none !important'
      )
    },
    showCustomCode() {
      this.$store.commit('toolsPanel_setItem', {
        id: 'editCustomCode',
      })
    },
    showComputed() {
      this.$store.commit('toolsPanel_setItem', {
        id: 'editComputed',
      })
    },
    showSettings() {
      this.$store.commit('toolsPanel_setItem', {
        id: 'editSettings',
      })
    },
    showBuildSchemaModal() {
      this.showSettings()
      this.$nextTick(() => {
        this.$bvModal.show('stupid-modal-thingy')
      })
    },
    showWorkflows() {
      this.$store.commit('toolsPanel_setItem', {
        id: 'editWorkflow',
      })
    },
    showSimpleWorkflowModal() {
      eventBus.$emit('showSimpleWorkflow')
    },
    showInviteUserModal() {
      eventBus.$emit('showInvateNewUserModal')
    },
  },
  mounted() {
    if (this.isHome) this.$refs.search_input.focus()
  },
}
</script>

<style lang="scss">
@import '~$scss/globals';

.search_icon,
.search_input {
  border-radius: 25px;
}
.search_input {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  &:focus {
    border-color: rgb(222, 226, 230);
  }
}
.search_icon {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.appNav {
  @include cf;
  position: relative;
  background-color: white;
  border-bottom: 1px solid #efefef;
  box-shadow: $vertical-strong-shadow;
  padding: {
    left: 15px;
    right: 15px;
  }
  &__controls {
    display: flex;
    min-height: 50px;
  }
  &__signOut {
    position: absolute;
    right: 20px;
    top: 17px;
  }
  &__logo {
    display: flex;
    align-items: center;
    padding-right: 7px;
    a {
      text-decoration: none;
    }
    img {
      width: 100px;
      margin-right: 16px;
    }
  }
  &__center {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    &.no_grow {
      flex-grow: 0;
    }
  }
  &__dashTitle {
    h2 {
      margin: 0 0 0 18px;
    }
  }
  &__items {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @include resetList;
  }
  &__item {
    position: relative;
    padding: 0 4px;
    svg {
      width: 20px;
      height: 20px;
    }
    .dropdown-toggle {
      padding: 0;
    }
    &:not(:first-child) {
      margin-left: 7px;
    }
  }

  &._navInSideBar {
    position: relative;
    // background: #ccc;
    padding-top: 0;
    // box-shadow: none !important;
    @include breakpoint(max-width 1199px) {
      .appNav__dashTitle {
        h2 {
          margin-left: 22px;
        }
      }
    }
    .appNav__controls {
      height: 50px;
    }
    .appNav__center {
      display: flex;
      align-items: center;
      h2 {
        color: #5e72e4;
      }
    }
    // .appNav__items {
    //   li {
    //     border-color: white;
    //   }
    //   a {
    //     color: white;
    //   }
    // }
  }
}
</style>
